'use client';

import { c as _c } from "react/compiler-runtime";
import { Spinner } from '@/components/ui/spinner';
import { useOnboarding } from './onboarding-context';
import { StepIntroduction } from './step-introduction';
import { StepPayItForward } from './step-pay-it-forward';
const STEP_COMPONENTS = {
  introduction: StepIntroduction,
  'pay-it-forward': StepPayItForward
} as const;
export function StepRenderer() {
  const $ = _c(8);
  const {
    currentStep,
    isComplete
  } = useOnboarding();
  if (isComplete || !currentStep) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div className="flex flex-1 items-center justify-center"><Spinner className="size-8 text-gray-500" /></div>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  const StepComponent = STEP_COMPONENTS[currentStep.id];
  if (!StepComponent) {
    let t0;
    if ($[1] !== currentStep.id) {
      t0 = <div className="flex flex-1 items-center justify-center"><p className="text-red-500">Unknown step: {currentStep.id}</p></div>;
      $[1] = currentStep.id;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    return t0;
  }
  let t0;
  if ($[3] !== currentStep.props) {
    t0 = currentStep.props || {};
    $[3] = currentStep.props;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== StepComponent || $[6] !== t0) {
    t1 = <StepComponent {...t0} />;
    $[5] = StepComponent;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}